import type { FelicitacionStepProps } from "./config";
import IllustratedStepCard from "./IllustratedStepCard";
import step2PreviewImage from "../../../assets/images/felicitacion/mockup1_v2.webp";

const Step2 = ({ selectedGrandpa }: FelicitacionStepProps) => {
	return (
		<IllustratedStepCard
			cardPadding="24px 24px 0"
			description="Escribe en la tarjeta su nombre y fecha de nacimiento para que sepamos a quién va dirigida y podamos enviársela."
			imageAlt={`Tarjeta con los datos de ${selectedGrandpa?.name ?? "la persona mayor"}`}
			imageAlign="flex-end"
			imageHeight="auto"
			imageJustify="center"
			imageMarginTop="0"
			imageMaxHeight="clamp(320px, 46vh, 420px)"
			imageSrc={step2PreviewImage}
			imageTransform="none"
			title="Facilítanos sus datos"
		/>
	);
};

export default Step2;
